import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-rapport-trimestriel',
  imports: [],
  templateUrl: './rapport-trimestriel.component.html',
  styleUrl: './rapport-trimestriel.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RapportTrimestrielComponent {

}
